<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
    persistent
  >
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon left color="warning">mdi-pause-circle</v-icon>
        {{ $t('customer.suspend-account') }}
      </v-card-title>

      <v-card-text class="pt-4">
        <v-alert type="warning" outlined class="mb-4">
          {{ $t('customer.suspend-account-warning') }}
        </v-alert>

        <v-form ref="form" v-model="valid">
          <v-select
            v-model="selectedReason"
            :items="reasonOptions"
            :label="$t('customer.suspension-reason') + ' *'"
            :rules="[v => !!v || $t('customer.suspension-reason-required')]"
            outlined
          />

          <v-textarea
            v-if="selectedReason === 'other'"
            v-model="customReason"
            :label="$t('customer.suspension-reason') + ' *'"
            :placeholder="$t('customer.suspension-reason-other-placeholder')"
            :rules="customReasonRules"
            outlined
            rows="3"
            counter
            maxlength="500"
          />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="close"
          :disabled="loading"
          small
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          color="warning"
          @click="confirm"
          :loading="loading"
          :disabled="!isFormValid"
          small
        >
          <v-icon left small>mdi-pause-circle</v-icon>
          {{ $t('customer.suspend') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SuspendCustomerDialog',

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      valid: false,
      loading: false,
      selectedReason: null,
      customReason: '',
    }
  },

  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },

    reasonOptions() {
      return [
        { text: this.$t('customer.suspension-reasons.duplicate'), value: 'duplicate' },
        { text: this.$t('customer.suspension-reasons.inactive'), value: 'inactive' },
        { text: this.$t('customer.suspension-reasons.terms-violation'), value: 'terms-violation' },
        { text: this.$t('customer.suspension-reasons.fake-account'), value: 'fake-account' },
        { text: this.$t('customer.suspension-reasons.other'), value: 'other' },
      ]
    },

    customReasonRules() {
      return [
        v => !!v?.trim() || this.$t('customer.suspension-reason-required'),
        v => (v && v.trim().length >= 10) || this.$t('customer.suspension-reason-min-length')
      ]
    },

    isFormValid() {
      if (!this.selectedReason) return false
      if (this.selectedReason === 'other') {
        return this.customReason?.trim()?.length >= 10
      }
      return true
    },

    finalReason() {
      if (this.selectedReason === 'other') {
        return this.customReason.trim()
      }
      // Retourne le libellé traduit pour les raisons prédéfinies
      const option = this.reasonOptions.find(o => o.value === this.selectedReason)
      return option ? option.text : this.selectedReason
    }
  },

  watch: {
    dialog(val) {
      if (val) {
        this.resetForm()
      }
    }
  },

  methods: {
    resetForm() {
      this.selectedReason = null
      this.customReason = ''
      this.valid = false
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },

    close() {
      this.dialog = false
      this.$emit('cancel')
    },

    confirm() {
      if (this.$refs.form.validate() && this.isFormValid) {
        this.loading = true
        this.$emit('confirm', this.finalReason)
      }
    },

    setLoading(value) {
      this.loading = value
    }
  }
}
</script>
